<template>
  <ul v-if="list && list.length" class="common-select-list">
    <li v-for="(item, i) in list"
        :key="i"
        class="common-select-list__item"
        :style="itemStyle"
        :class="[current === i && !item.disabled ? 'selected' : '', item.disabled ? 'disabled' : '']"
        @click="onSelect(i)">
      <slot :data="item"></slot>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'SelectList',
  props: {
    value: {
      type: Number
    },
    list: {
      type: Array
    },
    col: {
      type: Number,
      default: 1
    }
  },
  data(){
    return {
      current: this.value
    };
  },
  computed: {
    itemStyle(){
      return {
        width: this.col === 1 ? '100%' : `calc((100% - ${15 * (this.col - 1)}px) / ${this.col})`
      };
    }
  },
  watch: {
    value(val){
      if (val !== this.current){
        this.current = val;
      }
    }
  },
  methods: {
    onSelect(index){
      if (index === this.current){
        return;
      }
      this.current = index;
      this.$emit('input', index);
      this.$emit('change', this.list[index]);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/standard";

.common-select-list {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  &__item {
    margin-bottom: sizeTrans($space_15);
    padding: sizeTrans($space_15);
    border: 1px solid #000000;
    color: #000F16;
    cursor: pointer;

    &.disabled {
      border-color: #939799;
      color: #B6B6B6;
      pointer-events: none;
      cursor: not-allowed;
    }

    &.selected {
      border-color: #02BEBF;
    }
  }
}
</style>